/**
 * Limites explicitos del AI Core. Acotan el costo, el tamano del contexto enviado a un
 * proveedor y la superficie de ataque de una respuesta (acciones, longitud, anidamiento).
 */
export interface AICoreLimits {
  /** Longitud maxima del mensaje del usuario (caracteres). */
  readonly maxPromptLength: number;
  /** Longitud maxima del texto devuelto por un proveedor (caracteres). */
  readonly maxResponseLength: number;
  /** Acciones por respuesta (el contrato admite hasta 50; el AI Core es mas estricto). */
  readonly maxActionsPerResponse: number;
  /** Profundidad maxima de un Expression AST propuesto por la IA. */
  readonly maxExpressionDepth: number;
  /** Nodos maximos de un Expression AST propuesto por la IA. */
  readonly maxExpressionNodes: number;
}

export interface AIContextLimits {
  /** Campos (dimensiones + medidas) incluidos; los del analisis actual tienen prioridad. */
  readonly maxFields: number;
  readonly maxSynonymsPerField: number;
  readonly maxDescriptionLength: number;
  readonly maxMembersPerDimension: number;
  readonly maxBusinessRules: number;
  readonly maxDictionaryEntries: number;
  /** Tamano maximo del contexto serializado (bytes UTF-8). */
  readonly maxSerializedBytes: number;
}

export const DEFAULT_AI_CORE_LIMITS: AICoreLimits = {
  maxPromptLength: 500,
  maxResponseLength: 32_000,
  maxActionsPerResponse: 20,
  maxExpressionDepth: 12,
  maxExpressionNodes: 100,
};

export const DEFAULT_AI_CONTEXT_LIMITS: AIContextLimits = {
  maxFields: 200,
  maxSynonymsPerField: 10,
  maxDescriptionLength: 280,
  maxMembersPerDimension: 50,
  maxBusinessRules: 20,
  maxDictionaryEntries: 50,
  maxSerializedBytes: 64_000,
};
